import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {actions, Control, Form} from "react-redux-form";
import {Button} from "@material-ui/core";
import CustomInput from "../../../components/custom-input/custom-input";
import {useDispatch} from "react-redux";
import Loader from "react-loader-spinner";
import {getGeneralSettings, updateGeneralSettings} from "../../../services/generalSettings.service";
import _ from 'lodash';

export const GeneralOptionView: React.FC = () => {
    const {t} = useTranslation()
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setTimeout(() => setLoading(false), 1000);
        getGeneralSettings().then(
            (res) => {
                dispatch(actions.change('general.infoSendingTime', parseInt(res.infoSendingTime, 10)))
            }
        )
    }, [])
    const handleSubmit = (settings: any) => {
        updateGeneralSettings({
            infoSendingTime: _.get(settings, 'infoSendingTime', 1).toString()
        });
    }
    if (!loading) {
        return (
            <div className='d-flex justify-content-center w-100 align-items-start router-container'>
                <div className='card default-card w-100'>
                    <div className="card-body">
                        <div className='card-title-container'>
                            <span className='card-title'>{t('general')}</span>
                        </div>
                        <Form
                            model='general'
                            onSubmit={(settings) => handleSubmit(settings)}>
                            <div className='default-row'>
                                <div className='default-field-bigger'>
                                    <Control
                                        model={".infoSendingTime"}
                                        component={CustomInput}
                                        type='number'
                                        label={t('infoSendingTime')}
                                        mapProps={{
                                            helperText: () => t('infoSendingTime.helper')
                                        }}
                                        id={'infoSendingTime'} />
                                </div>
                            </div>
                            <div className='modal-action-row'>
                                <Button variant="contained" type='submit' color="primary" className='modal-default-button'>
                                    {t('apply')}
                                </Button>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
        )
    }
    return <div className='w-100 d-flex justify-content-center pt-5'>
        <Loader
            type="Puff"
            color="#555374"
            height={100}
            width={100}
            timeout={3000} //3 secs

        />
    </div>;
}